import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokens } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const loadMe = useCallback(async () => {
    if (!tokens.access()) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      tokens.clear();
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    tokens.set(data.access_token, data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* session may already be invalid */
    }
    tokens.clear();
    setUser(false);
  };

  const can = (perm) => !!user && user.permissions.includes(perm);

  return <AuthContext.Provider value={{ user, login, logout, can, reload: loadMe }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
